import { render } from "./projectIncomeViewer.vue?vue&type=template&id=4200de54&scoped=true"
import script from "./projectIncomeViewer.vue?vue&type=script&lang=js"
export * from "./projectIncomeViewer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4200de54"]])

export default __exports__